export default {
  sidebarMenu: {
    closeWaterValve: 'Uzavřít přísun vody',
    openWaterValve: 'Otevřít přísun vody',
  },
  menu: {
    dashboard: 'Dashboard',
    devices: 'Devices',
    reports: 'Reports',
    orders: 'Orders',
    settings: 'Settings',
    eshop: 'Eshop',
  },
  loginPage: {
    form:{
      username: 'Vaše přihlašovací jméno',
      password: 'Heslo',
      login: 'Přihlásit se',
      forgottenPassword: 'Zapomněl jsem heslo',
      errors: {
        badUsernameOrPasswordError: 'Špatné uživatelské jméno nebo heslo'
      }
    }
  },
  dashboardFilter: {
    fulltextSearchPlaceholder: 'Zadejte jméno obyvatele nebo číslo bytu',
    show: 'Zobrazit:',
    showSelect: {
      all: 'Vše',
      cold: 'Studená voda',
      warm: 'Teplá voda',
    },
    date: 'Datum:',
    dateSelect: {
      last24hours: 'Posledních 24 hodin',
      last48hours: 'Posledních 48 hodin',
      lastWeek: 'Poslední 7 dnů',
      lastMonth: 'Poslední 30 dnů',
    },
    lastUpdate: 'Poslední aktualizace:'
  },
  consumptionGraph: {
    state: 'Stav vodoměru',
    stateCalorimeter: 'Stav kalorimetru',
    dayConsumption: 'Denní spotřeba',
    monthlyConsumption: 'Mesíční spotřeba',
    type: {
      0: 'Studená voda',
      1: 'Teplá voda',
      2: 'Kalorimetr',
      3: 'Rozdělovač topných nákladů',
      null: ''
    }
  },
  objectManagerSelector: {
    selectObject: 'Zvolte objekt'
  },
  graphGroup: {
    resident: 'Obyvatel:'
  },
  createAccessPage: {
    description: "Zkontrolujte a zadejte své přihlašovací údaje.",
    form: {
      firstName: "Jméno",
      lastName: "Příjmení",
      password: 'Heslo',
      passwordAgain: 'Heslo znovu',
      submit: 'Přihlásit se'
    }
  },
  requestResetPassword: {
    description: 'Zadejte prosím Váš e-mail. Zašleme Vám instrukce pro resetování hesla.',
    form: {
      email: 'E-mail',
      submit: 'Odeslat'
    }
  },
  requestResetPasswordPage: {
    description: 'Nastavte si nové heslo.',
    form: {
      password: 'Heslo',
      passwordAgain: 'Heslo znovu',
      submit: 'Změnit heslo'
    }
  }
};
